/* eslint-disable no-unused-vars */
import ApiFetch from 'utils/apiFetch';
import { preparePath } from 'utils/preparePath';

const ApiFetchInstance = ApiFetch();

export const URLS = {
  contracts: '/digitalization/contracts',
  sections: '/digitalization/sections',
  sales: '/digitalization/sales',
  printDocument: '/digitalization/print-document',
  printDocumentPdf: '/digitalization/print-document/pdf',
  printNotePdf: '/digitalization/print-note/pdf/:noteId',
  documentPdf: '/digitalization/document/pdf',
};

export default {
  getContracts() {
    return ApiFetchInstance.get(preparePath(URLS.contracts));
  },
  getSections() {
    return ApiFetchInstance.get(preparePath(URLS.sections));
  },
  getSales() {
    return ApiFetchInstance.get(preparePath(URLS.sales));
  },
  printDocument(documentType, document) {
    return ApiFetchInstance.post(preparePath(URLS.printDocument), { documentType, document });
  },
  printDocumentAsPdf(documentType, document) {
    return ApiFetchInstance.post(preparePath(URLS.printDocumentPdf), { documentType, document }, { responseType: 'blob' });
  },
  printNoteAsPdf(noteId) {
    return ApiFetchInstance.get(preparePath(URLS.printNotePdf, { noteId }), { responseType: 'blob' });
  },
  printDigitalizedDocument(path) {
    return ApiFetchInstance.get(
      preparePath(URLS.documentPdf, {}, { path }),
      { responseType: 'blob' },
    );
  },
};
